import React from 'react';
import { includes } from 'lodash';
import { Form } from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';

const LayerOGCCollectionSelector = ({
  setUrlDefault,
  layerSubType,
  defaultUrl,
  handleURLChange
}) => {
  if (includes([LAYER_SUBTYPES.GEOJSON, LAYER_SUBTYPES.REALTIME], layerSubType)) {
    const [offset, setOffset] = React.useState(0);
    const [limit, setLimit] = React.useState(false);
    const [isFromOGC, setisFromOGC] = React.useState(
      defaultUrl.match(/startindex=([0-9]+)/) !== null
    );

    const getStartIndexAndLimit = url => {
      const startindex = url.match(/startindex=([0-9]+)/)[1];

      const defaultLimit = url.match(/limit=([0-9]+)/)[1];

      setOffset(parseInt(startindex, 10) / parseInt(defaultLimit, 10));
      setLimit(parseInt(defaultLimit, 10));
    };

    const updateURL = (url, startindex, newLimit) => {
      const newUrl = new URL(url);

      newUrl.searchParams.set('startindex', startindex);
      newUrl.searchParams.set('limit', newLimit);

      setUrlDefault(newUrl.href);
      handleURLChange();
    };
    React.useEffect(() => {
      if (isFromOGC) {
        getStartIndexAndLimit(defaultUrl);
      }
    }, []);
    React.useEffect(() => {
      setisFromOGC(defaultUrl.match(/startindex=([0-9]+)/) !== null);
    }, [defaultUrl]);

    return !isFromOGC ? (
      false
    ) : (
      <>
        <Form.Label>Change the startindex</Form.Label>
        <Form.Group>
          <Pagination>
            <Pagination.Prev
              disabled={offset === 0}
              onClick={() => {
                updateURL(defaultUrl, (offset - 1) * limit, limit);
                setOffset(offset - 1);
              }}
            />
            <Pagination.Item active>{offset}</Pagination.Item>
            <Pagination.Next
              // disabled={loading}
              onClick={() => {
                updateURL(defaultUrl, (offset + 1) * limit, limit);
                setOffset(offset + 1);
              }}
            />
          </Pagination>
        </Form.Group>
      </>
    );
  }
  return '';
};

export default LayerOGCCollectionSelector;
